import { HttpApiSchema } from "@effect/platform";
import { Schema } from "effect";

export class DatabaseError extends Schema.TaggedError<DatabaseError>()(
  "DatabaseError",
  { message: Schema.optional(Schema.String) },
  HttpApiSchema.annotations({ status: 500 }),
) {}

export class DataIntegrityError extends Schema.TaggedError<DataIntegrityError>()(
  "DataIntegrityError",
  { message: Schema.optional(Schema.String) },
  HttpApiSchema.annotations({ status: 500 }),
) {}
